module.exports = __webpack_public_path__ + "rvcnn_cover_logo_jewellry_fashion_design_rovcanin_handmade.jpg?63dbb7c260c2f115ec7eafebe47d5868";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/rvcnn_cover_logo_jewellry_fashion_design_rovcanin_handmade.jpg
// module id = 103
// module chunks = 0